import { constants } from "~/common/constants";
import { useStickyPromotionFlyout } from "~/components/Promotions";

export const useStickyNewsletterFlyout = (slug?: string) =>
  useStickyPromotionFlyout({
    slug,
    storageKey: constants.STICKY_NEWSLETTER_STORAGE_KEY,
    analyticsShowMessage: "Sticky Newsletter Rendered",
    analyticsDismissMessage: "Sticky Newsletter Dismissed",
  });
